import './scss/main.scss';

// js
import './js/languageSwitch.js';

// slider
import './js/slider.js';

// priceToggle
import './js/priceToggle.js';

// priceComparisonTable
import './js/priceComparisonTable.js';

// fixedNavOnScroll
import './js/fixedNavOnScroll.js';

// footer 
import './js/footer.js';

// tab 
import './js/tab.js';

// comments 
import './js/comments.js';

// newsletter
import './js/newsletter.js';

// navigation
import './js/navigation.js';
// auto-dl
import './js/auto-dl.js';

// mobileSlider
import './js/mobileSlider.js';

// scroll
import './js/clickToScroll.js';

// comparisonTable
import './js/comparisonTable.js';